import { Translation } from "./Translation";
export class Tag {

    constructor(label) {
        this.label = label || new Translation();
    }
}